// Calendar Events API client

import { apiClient, type ApiResponse } from './client'
import type { CalendarEventViewDto } from '@/types/calendarEvent'

export const calendarEventsApi = {
  /**
   * Get all calendar events for a workspace
   */
  async getWorkspaceEvents(workspaceId: string): Promise<ApiResponse<CalendarEventViewDto[]>> {
    return apiClient.get<CalendarEventViewDto[]>(`/api/Workspaces/${workspaceId}/CalendarEvents`)
  },

  /**
   * Get calendar events for a specific campaign
   * (Placeholder for future implementation)
   */
  async getCampaignEvents(workspaceId: string, campaignId: string): Promise<ApiResponse<CalendarEventViewDto[]>> {
    return apiClient.get<CalendarEventViewDto[]>(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/CalendarEvents`)
  },

  /**
   * Get calendar events for a specific web
   * (Placeholder for future implementation)
   */
  async getWebEvents(workspaceId: string, webId: string): Promise<ApiResponse<CalendarEventViewDto[]>> {
    return apiClient.get<CalendarEventViewDto[]>(`/api/Workspaces/${workspaceId}/Webs/${webId}/CalendarEvents`)
  },
}
